export class ReadReviewsClickedUseCase {
    public execute = () => {
        const reviewsSection = document.querySelector('.elc-reviews-wrapper');
        if (reviewsSection) {
            reviewsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };
}
